exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RIGcontainer {\n  background-image: url(/images/rig.jpg);\n  height: 800px;\n  background-size: cover;\n  background-repeat: no-repeat; }\n  .RIGcontainer .RIGheading {\n    font-size: 2.9em;\n    width: 40%;\n    color: white;\n    padding: 30px;\n    margin-left: 150px;\n    padding-top: 80px; }\n    .RIGcontainer .RIGheading span {\n      color: #ffc000; }\n  .RIGcontainer .RIGButton-container {\n    height: 30px;\n    color: white;\n    font-size: 1.5em;\n    margin-top: 180px; }\n    .RIGcontainer .RIGButton-container .RIGButton {\n      float: right;\n      padding: 20px;\n      margin-right: 60px;\n      border: 1px solid #ffc000;\n      cursor: pointer; }\n      .RIGcontainer .RIGButton-container .RIGButton span {\n        color: #ffc000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Retire/intro.scss
// module id = 1539
// module chunks = 0